import { useEffect, useRef } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import productImage from '../assets/product.jpg';
import './PremiumSoftChews.css';

gsap.registerPlugin(ScrollTrigger);

export const products = [
  {
    image: productImage,
    badge: 'BEST SELLER',
    name: 'Hip & Joint Soft Chews',
    description: 'Support mobility and an active lifestyle for your dog.',
  },
  {
    image: productImage,
    badge: 'IMMUNITY',
    name: 'Allergy & Immune Soft Chews',
    description: 'Daily support for immune strength and seasonal allergy defense.',
  },
  {
    image: productImage,
    badge: 'GUT HEALTH',
    name: 'Probiotic Soft Chews',
    description: 'A healthy gut and balanced digestive microflora for a happier dog.',
  },
  {
    image: productImage,
    badge: 'SKIN & COAT',
    name: 'Itch Relief Soft Chews',
    description: 'Soothing therapeutic care for healthy, radiant skin & coat.',
  },
];

export default function PremiumSoftChews({ onAdd }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return undefined;

    const animation = gsap.context(() => {
      const reveal = gsap.timeline({
        defaults: { ease: 'power3.out' },
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 94%',
          once: true,
          invalidateOnRefresh: true,
        },
      });

      reveal
        .fromTo('.soft-chews__eyebrow', { autoAlpha: 0, y: 18 }, { autoAlpha: 1, y: 0, duration: .45 })
        .fromTo('.soft-chews h2', { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: .6 }, '-=.22')
        .fromTo('.soft-chews__view-all', { autoAlpha: 0, y: 16 }, { autoAlpha: 1, y: 0, duration: .5 }, '-=.28')
        .fromTo('.soft-chews__card', { autoAlpha: 0, y: 42 }, { autoAlpha: 1, y: 0, duration: .65, stagger: .12, clearProps: 'transform' }, '-=.2');
    }, sectionRef);

    const refreshTrigger = () => ScrollTrigger.refresh();
    const images = sectionRef.current?.querySelectorAll('img') || [];
    images.forEach(image => image.addEventListener('load', refreshTrigger));
    window.addEventListener('load', refreshTrigger);
    requestAnimationFrame(refreshTrigger);

    return () => {
      images.forEach(image => image.removeEventListener('load', refreshTrigger));
      window.removeEventListener('load', refreshTrigger);
      animation.revert();
    };
  }, []);

  return (
    <section className="soft-chews" ref={sectionRef} aria-labelledby="soft-chews-heading">
      <div className="header-container">
        <div className="soft-chews__header">
          <div>
            <p className="soft-chews__eyebrow">DAILY NUTRIENTS</p>
            <h2 id="soft-chews-heading">Premium Soft Chews</h2>
          </div>
          <a className="soft-chews__view-all" href="/collections/supplements">View Full Supplement Line <FiArrowRight aria-hidden="true" /></a>
        </div>

        <div className="soft-chews__grid">
          {products.map(({ image, badge, name, description }) => (
            <article className="soft-chews__card" key={name}>
              <div className="soft-chews__image-wrap">
                {badge && <span className="soft-chews__badge">{badge}</span>}
                <img className="soft-chews__image" src={image} alt={`Trillium Paws ${name}`} />
              </div>
              <div className="soft-chews__content">
                <h3>{name}</h3>
                <p className="soft-chews__description">{description}</p>
                <div className="soft-chews__footer">
                  <button className="soft-chews__shop-link" type="button" onClick={() => { onAdd?.({ id: name.toLowerCase().replaceAll(/[^a-z0-9]+/g, '-'), name, description, image, price: 29.99 }); window.location.assign('/cart'); }}>
                    ADD TO CART <FiArrowRight aria-hidden="true" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

